import { render, staticRenderFns } from "./RoutesDashboard.vue?vue&type=template&id=101a959c&scoped=true"
import script from "./RoutesDashboard.vue?vue&type=script&lang=js"
export * from "./RoutesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a959c",
  null
  
)

export default component.exports